import { Vector3 as h } from "three";
const p = new h(), a = new h(), f = new h(), d = (e, r, o) => {
  const c = o.width / 2, n = o.height / 2;
  r.updateMatrixWorld(!1);
  const t = e.project(r);
  return t.x = t.x * c + c, t.y = -(t.y * n) + n, t;
}, g = (e, r, o, c = 1) => {
  const n = p.set(e.x / o.width * 2 - 1, -(e.y / o.height) * 2 + 1, c);
  return n.unproject(r), n;
}, w = (e, r, o, c) => {
  const n = d(f.copy(e), o, c);
  let t = 0;
  for (let s = 0; s < 2; ++s) {
    const i = a.copy(n).setComponent(s, n.getComponent(s) + r), l = g(i, o, c, i.z);
    t = Math.max(t, e.distanceTo(l));
  }
  return t;
};
export {
  w as calculateScaleFactor
};
//# sourceMappingURL=index3.js.map
